import { render, staticRenderFns } from "./DeductionTableComponent.vue?vue&type=template&id=5547662f&"
import script from "./DeductionTableComponent.vue?vue&type=script&lang=js&"
export * from "./DeductionTableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports